import React from 'react';
import {Text, TextProps, Platform} from 'react-native';
import * as WebBrowser from 'expo-web-browser';
import * as Linking from 'expo-linking';
import {t} from 'react-native-tailwindcss';

type Props = TextProps & {href: string};

export const Anchor: React.FC<Props> = (props) => {
  return (
    <Text
      {...props}
      accessibilityRole="link"
      style={[t.textBlue600, props.style]}
      onPress={(e) => {
        e.preventDefault();
        if (Platform.OS === 'web') {
          window.open(props.href, '_blank');
        } else {
          WebBrowser.openBrowserAsync(props.href);
        }
        props.onPress?.(e);
      }}
    />
  );
};
